import React from 'react';
import { Typography } from '@material-ui/core';
import Stack from '@mui/material/Stack';

export const About5 = () => {
  return (
    <div className="about-main-container">
      <div className="about-cover about-5-image" />
      <div className="container">
        <Stack spacing={3} className="about-stack about-5-stack ">
          <div className="about-title">Here’s another example</div>
          <Typography className="about-description">
            You can decide to produce super-exclusive “blockchain-only” releases
            or opt for blockchain “release windows.”
          </Typography>
          <Typography className="about-description">
            Here’s how release windows work: Imagine selling 1,000 music
            editions on MusicArt, during a release window and at a price and
            royalty that you determine. Once that exclusive release window
            closes, you can then distribute the same music across all other
            platforms, like Spotify. Or, simply use MusicArt to produce
            promotional NFT copies prior to release.
          </Typography>
          <Typography className="about-footer">
            MusicArt lets you do more with your music.
          </Typography>
        </Stack>
      </div>
    </div>
  );
};
